import { isClient } from '../../common/utils';
import { useInputMethodContext } from '../contexts/InputMethodContext/InputMethodContext';

const isTouchEnabled = () => {
  if (isClient()) {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }
  return false;
};

export const useHoverStylesClassName = () => {
  const { inputMethod } = useInputMethodContext();
  const isInputMethodMouse = inputMethod === 'mouse';

  return isInputMethodMouse && !isTouchEnabled()
    ? 'hover-styles-enabled'
    : undefined;
};
